import React from 'react';
import './FooterIcon.css';
import {faFacebookSquare, faTwitterSquare, faGithubSquare} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FooterIcons = () =>{
    return(
        <div className = "icons">
            <a href = "https:/twitter.com"  target = "_blank" rel="noopener noreferrer"><i><FontAwesomeIcon icon = {faTwitterSquare}/></i></a>
            <a href = "https://facebook.com" target = "_blank" rel="noopener noreferrer"><i><FontAwesomeIcon icon = {faFacebookSquare}/></i></a>            
            <a href = "https://github.com"  target = "_blank" rel="noopener noreferrer"><i><FontAwesomeIcon icon = {faGithubSquare}/></i></a>
        </div>
    )
};

export default FooterIcons;